import { Action, createReducer, on } from '@ngrx/store';
import * as InvitationsActions from './invitations.actions';
import { Invitations } from 'src/app/model/invitations';
import { ItemsPagination } from 'src/app/model/api/data-rest';


export interface State {
	invitationsList: Invitations[];
	invitationsHistory: Invitations[];
	sharing: boolean;
	shared: boolean;
	itemsPagination?: ItemsPagination;
	accepting: boolean;
	accepted: boolean;
	rejecting: boolean;
	rejected: boolean;
}

const initialState: State = {
	invitationsList: [],
	invitationsHistory: [],
	sharing: false,
	shared: false,
	accepting: false,
	accepted: false,
	rejecting: false,
	rejected: false,
};

const invitationsReducer = createReducer(
	initialState,

	on(InvitationsActions.getInvitationsList, (state) => ({
		...state,
		invitationsList: [],
	})),
	on(InvitationsActions.getInvitationsListSuccess, (state, payload) => ({
		...state,
		invitationsList: payload.invitationsList,
	})),
	on(InvitationsActions.getInvitationsPaginatedList, (state) => ({
		...state,
		invitationsList: [],
	})),
	on(InvitationsActions.getInvitationsPaginatedListSuccess, (state, payload) => ({
		...state,
		itemsPagination: payload.paging,
		invitationsList: payload.invitationsList,
	})),
	on(InvitationsActions.getInvitationsHistory, (state) => ({
		...state,
		invitationsHistory: [],
	})),
	on(InvitationsActions.getInvitationsHistorySuccess, (state, payload) => ({
		...state,
		invitationsHistory: payload.invitationsHistory,
	})),
	on(InvitationsActions.resetInvitationsShareDialog, (state) => ({ ...state, sharing: false, shared: false })),
	on(InvitationsActions.invitationsShareDevice, (state) => ({ ...state, sharing: true, shared: false })),
	on(InvitationsActions.invitationsShareDeviceSuccess, (state) => ({ ...state, sharing: false, shared: true })),
	on(InvitationsActions.invitationsShareDeviceFailed, (state) => ({ ...state, sharing: false, shared: false })),
	on(InvitationsActions.invitationsThGroupShare, (state) => ({ ...state, sharing: true, shared: false })),
	on(InvitationsActions.invitationsThGroupShareSuccess, (state) => ({ ...state, sharing: false, shared: true })),
	on(InvitationsActions.invitationsThGroupShareFailed, (state) => ({ ...state, sharing: false, shared: false })),
	on(InvitationsActions.invitationsAccept, (state) => ({ ...state, accepting: true, accepted: false })),
	on(InvitationsActions.invitationsAcceptSuccess, (state) => ({ ...state, accepting: false, accepted: true })),
	on(InvitationsActions.invitationsAcceptFailed, (state) => ({ ...state, accepting: false, accepted: true })),
	on(InvitationsActions.invitationsReject, (state) => ({ ...state, rejecting: true, rejected: false })),
	on(InvitationsActions.invitationsRejectSuccess, (state) => ({ ...state, rejecting: false, rejected: true })),
	on(InvitationsActions.invitationsRejectFailed, (state) => ({ ...state, rejecting: false, rejected: true })),
);

export const reducer = (state: State | undefined, action: Action): State => invitationsReducer(state, action);

